<!-- 西药编辑页 -->
<template>
  <div class="herb-wrapper" v-if="dataDone">
    <div class="herb-picker" @click="pickHerb">
      <div class="herb-type"><span class="required">药品名称</span></div>
      <div class="herb-content">
        <span class="placeholder" v-if="!herbName">请输入药品名称</span>
        <span class="name" v-else>{{scriptType == 3 ? `${herbName}` : `${herbCommonName}（${herbName}）`}}<br>{{herbFormat}}/{{unit}}</span>
      </div>
    </div>
    <div class="herb-edit-box">
      <div class="edit-title"><span class="required">用法用量</span></div>
      <div class="usage-container">
        <div class="usage-item">
          <div class="usage-type">剂量</div>
          <div class="usage-content">
            <div class="dose-box"><number-input class="number-input" :style="{color: dose == 0 ? '#999' : '#333'}" v-model="dose" :min="0" :max="999" /></div>
            <span class="unit">{{dosageUnit}}</span>
          </div>
        </div>
        <div class="usage-item">
          <div class="usage-type">方式</div>
          <div class="usage-content">
            <div class="way-picker" @click="wayListShow = true">
              <span class="placeholder" v-if="!way">请选择</span>
              <span class="way-text">{{way}}</span>
              <i class="arrow"></i>
            </div>
          </div>
        </div>
        <div class="usage-item">
          <div class="usage-type">频率</div>
          <div class="usage-content">
            <div class="frequency-picker" @click="pickFrequency">
              <span class="placeholder" v-if="!frequency.name">输入字母简写或汉字首字母进行检索</span>
              <span v-else>{{frequency.name}}({{frequency.short}})</span>
            </div>
          </div>
        </div>
        <div class="usage-item">
          <div class="usage-type">服用天数</div>
          <div class="usage-content">
            <div class="total-number"><number-input class="number-input" :style="{color: days == 0 ? '#999' : '#333'}" v-model="days" :min="0" :max="999" :integer="true" /></div>
            <span class="unit">天</span>
            <!-- <div class="empty-day disabled" v-if="!herbName">—</div>
            <div class="empty-day" v-else><span>{{days}}</span> 天/{{unit}}</div> -->
          </div>
        </div>
        <div class="usage-item">
          <div class="usage-type">发药量</div>
          <div class="usage-content">
            <!-- <div class="total-number"><number-input class="number-input" :style="{color: herbDosage == 0 ? '#999' : '#333'}" v-model="herbDosage" :min="0" :max="999" :integer="true" /></div> -->
            <div class="total-number">{{herbDosage}}</div>
            <span class="unit">{{unit}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="herb-edit-box">
      <div class="edit-title"><span>特殊说明</span></div>
      <div class="special-box">
        <div class="special-text">
          <textarea class="special-typer" v-model="special" v-ios-bug-fixed maxlength="100" placeholder="未填写则默认为无"></textarea>
          <span class="text-limit">{{special.length}}/100</span>
        </div>
        <div class="special-quick-picker">
          <div class="puick-item" v-for="item in specialData" @click="selectSpecial(item)">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="herb-control">
      <button class="control-button cancel" @click="back">取消</button>
      <button class="control-button save" @click="saveHerb" :disabled="saving">保存</button>
    </div>
    <!-- 药品搜索 -->
    <div class="search-container" v-show="herbSearchShow">
      <div class="search-results" v-show="herbSearchResultsShow">
        <template v-if="searchDone" v-for="item in herbSearchResults">
          <div class="result-item script" @click="pickHerbItem(item)">
            <div class="script-name">{{scriptType == 3 ? `${item.name}` : `${item.common_name}（${item.name}）`}}</div>
            <div class="script-herbs">{{item.specification}}/{{item.unit}}</div>
          </div>
        </template>

        <div class="empty-result" v-if="herbSearchResults.length == 0 && searchDone">暂无搜索结果</div>
        <div class="searching" v-if="!searchDone"><van-loading type="spinner" size="16px" /></div>
      </div>
      <div class="add-herb-typer">
        <input type="text" class="herb-search-input" ref="herbSearchInput" v-model="herbKey" v-ios-bug-fixed @blur="searchBlur" @input="searchHerbs($event)" placeholder="输入药品名称或首字母进行检索">
      </div>
    </div>
    <!-- 频率搜索 -->
    <div class="search-container" v-show="frequencySearchShow">
      <div class="search-results">
        <template v-for="item in frequencySearchResults">
          <div class="result-item frequency" @click="pickFrequencyAction(item)">{{item.name}}({{item.short}})</div>
        </template>

        <div class="empty-result" v-if="frequencySearchResults.length == 0">暂无搜索结果</div>
      </div>
      <div class="add-herb-typer">
        <input type="text" class="herb-search-input" ref="frequencySearchInput" v-model="searchKey" v-ios-bug-fixed @blur="searchBlur" @input="searchFrequency($event)" placeholder="输入字母简写或汉字首字母进行检索">
      </div>
    </div>


    <!-- 选择方式 -->
    <van-popup v-model="wayListShow" position="bottom" :style="{height: '60%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          方式
          <span class="close-popup" @click="wayListShow = false">取消</span>
        </div>
        <div class="data-wrapper special-list">
          <div class="special-item" :class="{'selected': item == way}" @click="chooseSpecial(item)" v-for="item in wayData">{{item}}</div>
        </div>
      </div>
    </van-popup>
    <x-dialog v-if="customizeWayShow" title="自定义" @close="customizeWayShow = false">
      <div class="customize-content">
        <div class="customize-text">
          <input type="text" class="customize-input" v-ios-bug-fixed ref="customizeInput" v-model="customizeWay">
        </div>
        <div class="customize-control">
          <button class="cancel" @click="customizeWayShow = false">取消</button>
          <button class="confirm" @click="saveCustomizeWay">保存</button>
        </div>
      </div>
    </x-dialog>

    <!-- 药材超量弹窗 -->
    <x-dialog v-if="excessHerbsShow" title="确认保存处方" @close="excessHerbsShow = false" dialogWidth="82%">
      <div class="excess-content">
        <div class="text">
          <p class="excess-tip">当前处方存在特殊情况，请确认已知晓，并加盖电子签章</p>
          <div class="excess-text">
            <div class="excess-data">{{scriptType == 3 ? herbName : herbCommonName}}<span v-if="isUnitExcess">超过单日最大剂量</span><span v-if="isUnitExcess && isExcess">及</span><span v-if="isExcess">用量超过{{herbMaxDosage}}天</span></div>
          </div>
        </div>
        <div class="control">
          <button class="cancel" @click="cancelEdit">修改</button>
          <button class="confirm" @click="saveScript">我已确认</button>
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<style lang="less">
  .herb-wrapper{
    min-height: 100vh;
    background: #FAFAFA;
    padding: 12px 8px;
    .herb-picker{
      background: #FFF;
      width: 100%;
      height: 64px;
      border-radius: 6px;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .herb-type{
        font-size: 15px;
        color: #666;
        flex-shrink: 0;
        font-weight: bold;
        span{
          position: relative;
          &.required::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            font-size: 15px;
            color: @error;
            margin-left: 1px;
            font-weight: bold;
          }
        }
      }
      .herb-content{
        flex: 1;
        padding-left: 21px;
        font-size: 15px;
        color: @black;
        display: flex;
        overflow: hidden;
        .placeholder{
          color: #999;
        }
        .name{
          font-size: 16px;
          line-height: 24px;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: @black;
          font-weight: bold;
        }
      }
    }
    .herb-edit-box{
      padding: 24px 16px 32px;
      background: #FFF;
      margin-top: 12px;
      border-radius: 6px;
      .edit-title{
        font-size: 15px;
        line-height: 21px;
        color: #666;
        font-weight: bold;
        span{
          position: relative;
          &.required::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            font-size: 15px;
            line-height: 15px;
            color: @error;
            margin-left: 1px;
            font-weight: bold;
          }
        }
      }
      .usage-container{
        margin-top: 20px;
        .usage-item{
          margin-top: 24px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          &:first-child{
            margin-top: 0;
          }
          .usage-type{
            font-size: 15px;
            line-height: 21px;
            color: @black;
            font-weight: bold;
            margin-right: 18px;
            flex-shrink: 0;
          }
          .usage-content{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .number-input{
              width: 72px;
              height: 36px;
              background: #F7F7F7;
              text-align: center;
              border-radius: 4px;
            }
            .unit{
              margin-left: 12px;
              font-size: 15px;
              line-height: 21px;
              color: @black;
            }
            .way-picker{
              position: relative;
              display: flex;
              align-items: center;
              padding: 0 28px 0 12px;
              border: 1px solid #E7EDF3;
              border-radius: 4px;
              font-size: 14px;
              height: 32px;
              .placeholder{
                color: #666;
              }
              .way-text{
                color: @black;
              }
              .arrow{
                position: absolute;
                top: 50%;
                right: 8px;
                transform: translateY(-1px);
                width: 0;
                height: 0;
                border-width: 4px;
                border-color: #666 transparent transparent transparent;
                border-style: solid dashed dashed dashed;
              }
            }
            .frequency-picker{
              width: 275px;
              height: 40px;
              display: flex;
              align-items: center;
              padding: 0 12px;
              font-size: 15px;
              background: #F7F7F7;
              border-radius: 4px;
              .placeholder{
                color: #999;
              }
            }
            .empty-day{
              padding-left: 14px;
              font-size: 17px;
              line-height: 23px;
              color: @black;
              &.disabled{
                color: #999;
              }
              span{
                font-size: 17px;
              }
            }
          }
        }
      }
      .special-box{
        margin-top: 12px;
        .special-text{
          width: 100%;
          position: relative;
          .special-typer{
            width: 100%;
            height: 96px;
            background: #F7F7F7;
            border-radius: 4px;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            color: @black;
            resize: none;
          }
          .text-limit{
            position: absolute;
            right: 8px;
            bottom: 8px;
            font-size: 12px;
            line-height: 12px;
            color: #999;
          }
        }
        .special-quick-picker{
          padding-top: 4px;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          .puick-item{
            margin: 12px 12px 0 0;
            padding: 8px 16px;
            background: #FAFAFA;
            font-size: 14px;
            line-height: 20px;
            color: #666;
            border-radius: 4px;
          }
        }
      }
    }
    .herb-control{
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 8px;
      button{
        @button-base();
        height: 36px;
        &.cancel{
          @button-border();
          width: 103px;
          background: transparent;
          margin-right: 16px;
          border-color: #999;
          color: #666;
        }
        &.save{
          flex: 1;
        }
      }
    }
    .search-container{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #FFF;
      box-shadow: 0px -2px 6px 0px rgba(54,104,166,0.06);
      .search-results{
        width: 100%;
        height: 64px;
        overflow-x: scroll;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        padding: 0 24px;
        .result-item{
          display: inline-flex;
          margin-right: 28px;
          height: 100%;
          &.script{
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
          }
          &.herb{
            align-items: center;
            vertical-align: top;
            font-size: 16px;
            font-weight: bold;
            color: @black;
          }
          &.frequency{
            align-items: center;
            vertical-align: top;
            font-size: 15px;
            color: @black;
          }
          .script-name{
            font-size: 16px;
            line-height: 22px;
            color: @black;
            font-weight: bold;
            span{
              position: relative;
              top: -2px;
              display: inline-block;
              margin-left: 6px;
              height: 16px;
              padding: 0 4px;
              font-size: 12px;
              line-height: 16px;
              font-weight: normal;
              color: #999;
              border: 1px solid #999;
            }
          }
          .script-herbs{
            margin-top: 1px;
            font-size: 12px;
            line-height: 17px;
            color: #999;
          }
        }
        .empty-result{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          color: #999;
        }
        .searching{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          color: #666;
        }
      }
      .add-herb-typer{
        position: relative;
        padding: 12px 16px;
        box-shadow: 0px -2px 6px 0px rgba(199,163,97,0.06);
        z-index: 10;
        .herb-search-input{
          width: 100%;
          background: #F3F3F3;
          height: 40px;
          overflow: hidden;
          padding: 0 20px;
          font-size: 16px;
          line-height: 22px;
          border-radius: 4px;
        }
      }
    }
    // 服用方式
    .special-list{
      height: 100%;
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
      .special-item{
        width: 100%;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        color: @black;
        border-bottom: 1px solid #F3F3F3;
        text-align: center;
        &.selected{
          color: @xile;
        }
      }
    }
    // 自定义服用方式
    .customize-content{
      padding: 20px 0 24px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .customize-text{
        width: 250px;
        .customize-input{
          width: 100%;
          height: 40px;
          font-size: 16px;
          color: @black;
          padding: 0 12px;
          background: #F7F7F7;
          border-radius: 4px;
        }
      }
      .customize-control{
        margin-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 119px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }

    // 超量弹窗
    .excess-content{
      padding: 24px 28px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .excess-tip{
        font-size: 15px;
        line-height: 21px;
        color: @black;
        text-align: left;
        font-weight: bold;
      }
      .text{
        padding-top: 4px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        font-size: 16px;
        color: @black;
        .excess-text{
          margin-top: 12px;
          font-size: 14px;
          line-height: 20px;
          text-align: left;
          .excess-type{
            color: @black;
            font-weight: normal;
          }
          .excess-data{
            margin-top: 4px;
            color: @error;
          }
        }

      }
      .control{
        margin-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 117px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 13px;
          }
          &.confirm{}
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import numberInput from '@/components/Common/numberInput'
  import xDialog from '@/components/Common/dialog'
  import frequency from '@/config/frequency.js'
  export default {
    data() {
      return {
        // 剂型
        scriptType: parseInt(this.$route.query.script_type),
        dataDone: true,
        // 药品ID
        herbId: '',
        herbCode: '',
        // 药品最大用量
        herbMaxDosage: null,
        // 药品单日最大用量
        herbMaxDosagePreDay: null,
        // 药品多种价格
        price: {},
        // 药品通用名
        herbCommonName: '',
        // 药品名称
        herbName: '',
        // 药品生产商
        herbProductor: '',
        // 药品规格
        herbFormat: '',
        // 药品单规格剂量
        herbFormatNum: null,
        // 搜索关键字
        herbKey: '',
        herbSearchShow: false,
        herbSearchResultsShow: false,
        herbSearchResults: [],
        // 是否搜索完成
        searchDone: false,
        // 剂量
        dose: 0,
        // 剂量单位
        dosageUnit: '',

        // 发药量单位
        unit: '',
        // 服用方式
        way: '',
        wayData: ['口服', '口服（舌下含化）', '口服（嚼服）', '外用', '清洁灌肠', '肛用', '点眼', '漱口', '雾化吸入', '自定义'],
        wayListShow: false,
        // 自定义服用方式
        customizeWayShow: false,
        customizeWay: '',
        // 频率
        searchKey: '',
        frequency: {
          name: '',
          short: '',
          num: null,
        },
        frequencySearchShow: false,
        frequencySearchResults: [],
        frequencyData: frequency,
        // 天数
        days: 0,
        // 特殊说明
        special: '',
        specialData: ['饭后一小时服', '饭前一小时服', '空腹服', '晨起服', '备孕禁服', '怀孕禁服', '经期停服', '感冒停服'],
        timer: null,
        // 保存中
        saving: false,
        // 超量弹窗
        excessHerbsShow: false,
        herbData: {},
        // 药品超量信息
        isExcess: false,
        isUnitExcess: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      scriptInfo() {
        return this.$store.state.prescriptionData || {};
      },
      herbInfo() {
        return this.$store.state.herbsData || {};
      },
      herbDosage() {
        // 计算发药量
        if(!this.herbName) {
          return '—';
        }else {
          let dosage = 0;
          dosage = this.dose * this.frequency.num * this.days / parseFloat(this.herbFormatNum);
          return Math.ceil(dosage || 0);
        }
      }
    },
    components: {
      numberInput,
      xDialog
    },
    created() {
      if(this.herbInfo && this.herbInfo.name) {
        this.herbId = this.herbInfo.id;
        this.herbCode = this.herbInfo.code;
        this.herbMaxDosage = parseFloat(this.herbInfo.max_dosage) || null;
        this.herbMaxDosagePreDay = parseFloat(this.herbInfo.unit_max_dosage) || null;
        // 名称
        this.herbName = this.herbInfo.name;
        this.herbCommonName = this.herbInfo.common_name || '';
        // 生产商
        this.herbProductor = this.herbInfo.manufacturer;
        // 规格
        this.herbFormat = this.herbInfo.specification;
        this.herbFormatNum = this.herbInfo.spec;
        // 剂量
        this.dose = parseFloat(this.herbInfo.dosage);
        // 剂量单位
        this.dosageUnit = this.herbInfo.dosage_unit;
        // 用法
        this.way = this.herbInfo.usage;
        // 频率
        this.frequency = {
          name: this.herbInfo.frequency,
          short: this.herbInfo.fq,
          num: this.herbInfo.frequency_num,
        }
        // 天数
        this.days = this.herbInfo.days;
        // 单位
        this.unit = this.herbInfo.unit;
        // 发药量
        this.way = this.herbInfo.usage;
        this.unit = this.herbInfo.unit;
        this.price = {
          originalPrice: this.herbInfo.price,
          pushMoney: this.herbInfo.push_money,
          settlementPrice: this.herbInfo.settlement_price,
          tradePrice: this.herbInfo.trade_price || 0,
        }
        // this.herbDosage = this.herbInfo.num;
        this.special = this.herbInfo.remark;
        // 清空store中保存的临时数据
        this.$store.commit('clearHerbsData');
      }
      this.dataDone = true;
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      // 选择药品
      pickHerb() {
        this.herbSearchShow = true;
        this.$nextTick(() => {
          this.$refs.herbSearchInput.focus();
        })
      },
      searchBlur() {
        setTimeout(() => {
          this.herbSearchShow = false;
          this.herbSearchResultsShow = false;
          this.herbSearchResults = [];
          this.herbKey = '';

          this.frequencySearchShow = false;
          this.frequencySearchResults = [];
          this.searchKey = '';
          this.searchDone = false;
          window.scrollTo(0, 0);
        }, 50);
      },
      // 搜索药品
      searchHerbs($event) {
        if(this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if(this.herbKey != '') {
            this.searchDone = false;
            this.herbSearchResults = [];
            this.herbSearchResultsShow = true;
            this.$root.post('/getDrugName', {
              doc_id: this.userInfo.user_id,
              search: this.herbKey,
              company_name: this.scriptType
            }).then(data => {
              this.searchDone = true;
              this.herbSearchResults = data || [];
            })
          }
          this.timer = null;
        }, 500)
      },
      // 选中药品
      pickHerbItem(item) {
        this.herbId = item.id;
        this.herbCode = item.code;
        this.herbMaxDosage = parseFloat(item.max_dosage) || null;
        this.herbMaxDosagePreDay = parseFloat(item.unit_max_dosage) || null;
        this.herbName = item.name;
        this.herbCommonName = item.common_name || '';
        this.herbProductor = item.manufacturer;
        this.herbFormat = item.specification;
        this.herbFormatNum = parseFloat(item.spec);
        this.dose = parseFloat(item.dosage);
        this.dosageUnit = item.dosage_unit;
        let index = this.frequencyData.findIndex(stuff => {
          return stuff.short === item.fq;
        })
        this.frequency = {
          name: item.frequency,
          short: item.fq,
          num: this.frequencyData[index].num
        }
        this.days = 0;
        this.way = item.usage;
        this.unit = item.unit;
        this.price = {
          originalPrice: item.price,
          pushMoney: item.push_money,
          settlementPrice: item.settlement_price,
          tradePrice: item.trade_price,
        }
        // this.herbDosage = 1;
      },
      // 选择频率
      pickFrequency() {
        this.frequencySearchShow = true;
        this.frequencySearchResults = this.frequencyData
        this.$nextTick(() => {
          this.$refs.frequencySearchInput.focus();
        })
      },
      // 搜索频率
      searchFrequency() {
        if(this.searchKey) {
          this.frequencySearchResults = this.frequencyData.filter((frequency) => {
            return Object.keys(frequency).some((key) => {
              return String(frequency[key]).toLowerCase().indexOf(this.searchKey) > -1;
            })
          })
        }else {
          this.frequencySearchResults = this.frequencyData;
        }
      },
      pickFrequencyAction(item) {
        this.frequency = item;
      },
      selectSpecial(item) {
        // 字数即将大于最大值时取消操作
        let text = this.special + `，${item}`;
        if(text.length >= 100) return;
        if(this.special) {
          this.special += `，${item}`;
        }else {
          this.special = item;
        }
      },
      chooseSpecial(item) {
        this.wayListShow = false;
        if(item == '自定义') {
          this.customizeWayShow = true;
          this.$nextTick(() => {
            this.$refs.customizeInput.focus();
          })
        }else {
          this.way = item;
        }
      },
      saveCustomizeWay() {
        if(!this.customizeWay) {
          this.$notify('请输入自定义的方式');
          return;
        }
        this.way = this.customizeWay;
        this.customizeWayShow = false;
      },
      // 保存药品
      saveHerb() {
        if(!this.herbName) {
          this.$notify('请先添加药品');
          return;
        }
        // 检测是否有药名重复
        if(this.scriptInfo.herbList && this.scriptInfo.herbList.length > 0 && this.$route.query.edit_type == 'new') {
          let repeatHerb = false;
          this.scriptInfo.herbList.forEach(item => {
            if(item.name == this.herbName) {
              repeatHerb = true;
            }
          })
          if(repeatHerb) {
            this.$notify('无法添加重复名称的药品');
            return;
          }
        }

        if(this.dose == 0) {
          this.$notify('剂量不能为0');
          return;
        }
        if(this.days == 0) {
          this.$notify('服用天数不能为0');
          return;
        }
        console.log(this.scriptInfo);
        let totalPrice = ((this.price.originalPrice / 10000) * this.herbDosage).toFixed(2);
        console.log(totalPrice)
        // 判断药品超量信息
        this.isExcess = this.days > this.herbMaxDosage;
        this.isUnitExcess = (this.dose * this.frequency.num) > this.herbMaxDosagePreDay;
        // 保存数据
        this.herbData = {
          id: this.herbId,
          code: this.herbCode,
          max_dosage: this.herbMaxDosage,
          unit_max_dosage: this.herbMaxDosagePreDay,
          name: this.herbName,
          common_name: this.herbCommonName || '',
          manufacturer: this.herbProductor,
          specification: this.herbFormat,
          spec: this.herbFormatNum,
          unit: this.unit,
          usage: this.way,
          frequency: this.frequency.name,
          fq: this.frequency.short,
          frequency_num: this.frequency.num,
          dosage_unit: this.dosageUnit,
          dosage: this.dose,
          days: this.days,
          num: this.herbDosage,
          price: this.price.originalPrice,
          push_money: this.price.pushMoney,
          settlement_price: this.price.settlementPrice,
          trade_price: this.price.tradePrice,
          totalPrice,
          isExcess: this.isExcess,
          isUnitExcess: this.isUnitExcess,
          remark: this.special || '',
        }
        if(this.herbData.isExcess || this.herbData.isUnitExcess) {
          this.excessHerbsShow = true;
        }else {
          this.saveScript();
        }
      },
      cancelEdit() {
        this.excessHerbsShow = false;
      },
      saveScript() {
        let isEdit = this.scriptInfo.herbList.findIndex(item => {
          return this.herbData.id == item.id
        })
        if(isEdit != -1) {
          this.scriptInfo.herbList[isEdit] = this.herbData
        }else {
          this.scriptInfo.herbList.push(this.herbData);
        }
        this.$store.commit('setPrescriptionData', this.scriptInfo);
        this.$router.go(-1);
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Diagnose/herbWestEdit.vue